import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Dolphin Watching Vilamoura · Private Yacht · Morningstar";
const DESC = "Private dolphin watching from Vilamoura aboard Morningstar — small-group, respectful encounters with Algarve dolphins, combined with a swim stop and Portuguese tapas.";
const PATH = "/dolphin-watching-vilamoura";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/dolphin-watching-vilamoura")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Dolphin Watching · Vilamoura · Algarve",
        title: "Private dolphin watching from Vilamoura aboard ",
        titleAccent: "Morningstar.",
        sub: "A small private group, a slow approach and the open Algarve sea — encounters with common, bottlenose and (in spring) striped dolphins, paired with a swim stop and tapas.",
        ctaPrimary: "View options",
        ctaSecondary: "Ask about dolphins",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "dolphin watching Vilamoura, dolphin tour Vilamoura, dolphin cruise Algarve, private dolphin watching Vilamoura",
      altPath: { en: PATH, pt: "/pt/observacao-de-golfinhos-vilamoura" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private Dolphin Watching from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Dolphin Watching Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("en")) },
      ],
    }),
});
